
import { FlashMessageDto } from '../../../dto/flashmessage/get/flashmessagedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface SetFlashMessageRequest extends APIRequest
{
    getFlashMessageRequest(): FlashMessageDto;
}

export class SetFlashMessageRequestImpl extends APIRequestDtoImpl implements SetFlashMessageRequest
{
    constructor(private getFlashMessageData: FlashMessageDto)
    {
        super();
    }

    getFlashMessageRequest(): FlashMessageDto
    {
        return this.getFlashMessageData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessagerequest.tsx